import clsx from "clsx";
import { Link } from "react-router-dom";

import { date, text, rightColHeader } from "../styles";
import { routesFlat } from "@routes";
import { RocketIcon } from "@assets/icons";

export default function Featured() {
    return (
        <>
            <div className={rightColHeader}>featured update</div>
            {/* TODO: replace with link newfeed URI */}
            <Link to="https://www.youtube.com/watch?v=Qbsc-rGQc5E">
                <div className={clsx(date + " mt-2 tracking-wider")}>
                    June 18, 2026
                </div>
                <div className={clsx(text + " line-clamp-3")}>
                    Watch CTrees' recent webinar, Measuring What Matters: MRV for High-Integrity JREDD+.
                </div>
            </Link>

            <Link to="https://www.youtube.com/watch?v=Qbsc-rGQc5E" target="_blank" className="mt-1 flex text-sm font-bold">
                <RocketIcon />
                <div className="ml-2 border-b-[1px] border-b-red">
                    Watch the webinar
                </div>
            </Link>
        </>
    );
}
